const LicenseFooter = () => {
  return (
    <div className="absolute bottom-1 right-1 text-xs text-gray-300/10 hover:text-white/10 transition-colors">
      <a href="https://pinkpixel.dev" className="text-pink-400/30 hover:text-pink-400 opacity-50">
        Pink Pixel OS
      </a> © 2025 by{' '}
      <a href="https://github.com/pinkpixel-dev" className="text-pink-400/30 hover:text-pink-400 opacity-50">
        Pink Pixel
      </a> is licensed under{' '}
      <a href="https://creativecommons.org/licenses/by/4.0/" className="text-pink-400/30 hover:text-pink-400 opacity-50">
        CC BY 4.0
      </a>.
      <img src="https://mirrors.creativecommons.org/presskit/icons/cc.svg" alt="" className="inline w-2 h-2 opacity-10 ml-1" />
      <img src="https://mirrors.creativecommons.org/presskit/icons/by.svg" alt="" className="inline w-2 h-2 opacity-10 ml-1" />
    </div>
  )
}

export default LicenseFooter